/* eslint-disable no-underscore-dangle */
import { Howler, Howl } from 'howler';
import Env from './Env';

let isHtml5Mode = false;

const setHtml5Mode = (bool = false) => {
  if (!Env.deviceDetails.isSafari) {
    return;
  }
  Howler.usingWebAudio = bool;
  isHtml5Mode = bool;
};

class AquaHowl extends Howl {
  constructor(o = {}) {
    // remove custom options and call Howl constructor with the rest
    const { onhalt, onwillunload, unloadOnEnd = true, ...delegated } = o;

    super({ html5: isHtml5Mode, ...delegated });

    const self = this;

    // add 'halt' and 'willunload' event listener
    self._onhalt = onhalt ? [{ fn: onhalt }] : [];
    self._onwillunload = onwillunload ? [{ fn: onwillunload }] : [];

    self.on('end', () => {
      self._emit('halt', null);
      if (unloadOnEnd && !o.loop) {
        self.unload();
      }
    });

    self.on('stop', () => {
      self._emit('halt', null);
    });

    self.on('pause', () => {
      self._emit('halt', null);
    });
  }

  unload() {
    const self = this;

    // emit 'willunload' event and call parent unload
    self._emit('willunload', null);

    super.unload();
  }
}

const parseHowlConfig = (audio, options = {}) => {
  const config = audio && audio.src ? audio : {
    ...options,
    src: audio,
  };

  if (!Array.isArray(config.src)) {
    config.src = [config.src];
  }

  return config;
};

export {
  Howler,
  Howl,
  AquaHowl,
  parseHowlConfig,
  setHtml5Mode,
};

export default AquaHowl;
